import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15d07cc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "c-multiple-checkbox"
}
const _hoisted_2 = { class: "col-12 c-checkbox-header" }
const _hoisted_3 = {
  key: 0,
  class: "bold"
}
const _hoisted_4 = {
  key: 1,
  class: "bold",
  style: {"color":"var(--secondary)","user-select":"none"}
}
const _hoisted_5 = { class: "main-checkbox mt25" }
const _hoisted_6 = { class: "bold mb5" }
const _hoisted_7 = ["checked", "onChange", "disabled"]
const _hoisted_8 = ["checked", "onChange", "disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 1 }

export function render(_ctx, _cache) {
  return (_ctx.items[0])
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.label)), 1))
            : _createCommentVNode("", true),
          (!_ctx.isDisabled)
            ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectAll) = $event)),
                  class: "input-checkbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.selectAll]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('componentSelectAndDeselectAll')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (group) => {
            return (_openBlock(), _createElementBlock("div", {
              key: group?.[_ctx.itemValue],
              class: "col-6 col-md-6 col-sm-12 c-checkbox-wrapper"
            }, [
              _createElementVNode("label", _hoisted_6, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: _ctx.isGroupSelected(group),
                  onChange: $event => (_ctx.toggleGroupSelected(group)),
                  class: "input-checkbox",
                  disabled: _ctx.isDisabled
                }, null, 40, _hoisted_7),
                _createTextVNode(" " + _toDisplayString(group?.[_ctx.itemLabel] || "N/A"), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group?.children, (child) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: child?.[_ctx.itemValue],
                  style: {"margin-left":"28px"},
                  class: _normalizeClass([{'mt10': child?.[_ctx.itemLabel]?.includes('View')}, "mt10"])
                }, [
                  _createElementVNode("label", {
                    class: _normalizeClass({'txt-info bold': child?.[_ctx.itemLabel]?.includes('View')})
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _ctx.isSelected(child),
                      onChange: $event => (_ctx.toggleSelect(child)),
                      class: "input-checkbox",
                      disabled: _ctx.isDisabled
                    }, null, 40, _hoisted_8),
                    _createTextVNode(" " + _toDisplayString(child?.[_ctx.itemLabel] || "N/A"), 1)
                  ], 2)
                ], 2))
              }), 128)),
              _hoisted_9
            ]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, " Something wrong... "))
}